import { publicEnv } from '@/utils/public-env'

/**
 * The PostHog project key, for both the browser client and server-side flag
 * evaluation.
 *
 * It is a public client token, so a default ships in the bundle — mirroring
 * atlas-mobile's app.config.ts — and the env var only overrides it. Both
 * readers MUST go through this one function: the browser used to fall back to
 * the default while the server did not, and no deploy sets
 * `NEXT_PUBLIC_POSTHOG_KEY`, so every server-evaluated flag resolved `false`
 * in prod while the same flag read `true` in the browser. That silently shut
 * both native invoicing lanes for every org, the test org included.
 *
 * Dependency-free (no posthog-js) so server code can import it.
 */
const DEFAULT_POSTHOG_KEY = 'phc_tNSmtJzWm8j9PxgR6Uqs54QsjyKWHA5NEFELPbaguYz'

export function posthogApiKey(): string {
  return publicEnv('NEXT_PUBLIC_POSTHOG_KEY') ?? DEFAULT_POSTHOG_KEY
}
